import { computed } from 'vue';

import useTableSearchState from '../search/useTableSearchState';
import {
  getSearchOrderFromQuery,
  getSearchOrderToQuery,
  type OrderSearchParams,
} from './functions';

import { toKey } from '@/util/search/getKey';

export interface SortingValues<KeyColumns extends string> {
  column: KeyColumns,
  order: 'desc' | 'asc',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useTableSearchOrder = <ColumnKey extends string, OnSearchType extends Record<string, any | string | undefined | null | number | boolean | undefined>>(
  setURL?: boolean,
) => {
  const data = useTableSearchState<OrderSearchParams<ColumnKey>, OrderSearchParams<ColumnKey>>(
    getSearchOrderToQuery,
    getSearchOrderFromQuery,
    setURL,
  );

  const sort = computed<SortingValues<ColumnKey> | undefined>(() => {
    if (data.query.value.orderBy && data.query.value.orderBy.length > 0) {
      return {
        column: data.query.value.orderBy[0].column,
        order: data.query.value.orderBy[0].order === 'ASC' ? 'asc' : 'desc',
      };
    }
    return undefined;
  });

  const onSearch = (values: Partial<OnSearchType>) => {
    const keyValues = toKey(values);
    data.setSearch(keyValues);
    data.onSearch();
  };

  return {
    ...data,
    sort,
    onSearch,
  };
};

export default useTableSearchOrder;
